var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-border-t tw-border-0 tw-border-infinity-card-border tw-border-solid"},[_c('buy-button',{attrs:{"item":_vm.item,"label":_vm.label,"variant":"itemTileButton"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }